/**
 * My Campaigns
 *
 * javascript
 *
 * @category  Javascript
 * @package   My_Campigns
 * @author    Javier Mijares <support@video2market.com>
 * @copyright 2020 -
 * @license   Optime Consulting
 * @link      https://www.video2market.com/my-campigns.php
 */
import { createApp, configureCompat } from 'vue';
import { createPinia } from 'pinia';
// components
import Portfolio from '@/portfolio/pages/portfolio.vue';

// Create Vue app
const appPortfolio = createApp(Portfolio);

// Create Pinia store
const pinia = createPinia();
appPortfolio.use(pinia);

// Mount the app
appPortfolio.mount('#appPortfolio');

